export function toolTempUploadKey(type: string, ...parts: string[]): string {
  return ['tool-temp', type, ...parts].join(':');
}
